import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import TaskAltIcon from '@mui/icons-material/TaskAlt';

import ProgressTracker from '@ui-parts/ProgressTracker';
import MessageArea from '@ui-parts/MessageArea';
import LinkButton from '@ui-parts/LinkButton';

import { PALETTE } from '~/assets/styles/base';
import { ROUTES } from '~/constants/routes';
import { PROGRESS_TRACKER_LABELS, PROGRESS_TYPE, SURVEY_PROGRESSES } from '~/constants';

const MessageAreaWrapper = styled.div`
  max-width: 706px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 58px auto 0;
`;

const StyledTaskAltIcon = styled(TaskAltIcon)`
  color: ${PALETTE.text.primary};
  font-size: 4rem;
`;

const SurveyApplyCompleted = () => {
  const { t } = useTranslation();

  return (
    <>
      <ProgressTracker
        width="618px"
        labels={(PROGRESS_TRACKER_LABELS as Record<string, Array<string>>)[
          PROGRESS_TYPE.SURVEY
        ].map((label) => t(label))}
        currentNum={SURVEY_PROGRESSES[ROUTES.USER.SURVEY_APPLY_COMPLETED]}
      />

      <MessageAreaWrapper>
        <MessageArea
          title={t('surveyApplyCompleted.messageArea.title')}
          message={t('surveyApplyCompleted.messageArea.message')}
          desc={t('surveyApplyCompleted.messageArea.desc')}
          button={
            <LinkButton
              label={t('surveyApplyCompleted.messageArea.linkButton')}
              variant="outlined"
              href={ROUTES.USER.MYPAGE}
            />
          }
        >
          <StyledTaskAltIcon />
        </MessageArea>
      </MessageAreaWrapper>
    </>
  );
};

export default SurveyApplyCompleted;
